import { IconType } from "../icon-props";

const Next: IconType = (
  <>
    <path d="M23.3333 24.516C22.9556 24.516 22.6391 24.3878 22.384 24.1314C22.128 23.8758 22 23.5588 22 23.1804V9.82393C22 9.44549 22.128 9.12806 22.384 8.87161C22.6391 8.61606 22.9556 8.48828 23.3333 8.48828C23.7111 8.48828 24.0276 8.61606 24.2827 8.87161C24.5387 9.12806 24.6667 9.44549 24.6667 9.82393V23.1804C24.6667 23.5588 24.5387 23.8758 24.2827 24.1314C24.0276 24.3878 23.7111 24.516 23.3333 24.516ZM9.40001 23.147C8.95557 23.4586 8.50001 23.4809 8.03334 23.2138C7.56668 22.9467 7.33334 22.546 7.33334 22.0117V10.9926C7.33334 10.4584 7.56668 10.063 8.03334 9.80656C8.50001 9.55101 8.95557 9.56793 9.40001 9.85732L17.6667 15.4003C18.0667 15.6674 18.2667 16.0347 18.2667 16.5022C18.2667 16.9696 18.0667 17.3369 17.6667 17.6041L9.40001 23.147Z" />
  </>
);

export default Next;
